"use client";
import { useState } from "react";
import type { EmbeddedFundIndustryAnalysis } from "@/lib/types/industry";
import { IndustryFreshnessBanner } from "./IndustryFreshnessBanner";
import { IndustryStructuralCard } from "./IndustryStructuralCard";
import { IndustryRecentEvents } from "./IndustryRecentEvents";

export function FundIndustrySection({ data }: { data: EmbeddedFundIndustryAnalysis }) {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="fund-industry-landscape" className="scroll-mt-20 space-y-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-xl font-semibold text-slate-100">Industry Landscape for Your Holdings</h2>
        <IndustryFreshnessBanner cacheGeneratedAt={data.cacheGeneratedAt} />
      </div>

      <div className="space-y-2">
        {data.sectorsAnalyzed.map((s, i) => {
          const isOpen = openIdx === i;
          return (
            <div key={s.sector} className="rounded border border-slate-700 bg-slate-900">
              <button
                type="button"
                onClick={() => setOpenIdx(isOpen ? -1 : i)}
                className="flex w-full items-center justify-between p-3 text-left"
                aria-expanded={isOpen}
              >
                <span className="flex items-center gap-2 text-sm font-medium text-slate-100">
                  <span>{isOpen ? "▼" : "▶"}</span>
                  {titleCase(s.sector)}
                </span>
                <span className="text-xs text-slate-400">
                  {Math.round(s.weight * 100)}% of portfolio
                </span>
              </button>
              {isOpen && (
                <div className="space-y-4 border-t border-slate-800 p-3">
                  <IndustryStructuralCard structural={s.structural} />
                  <IndustryRecentEvents recent={s.recent} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}

function titleCase(s: string) {
  return s.replace(/\b\w/g, (c) => c.toUpperCase());
}
